/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 8/2/2023
 */

import BaseObject from "@shared/BaseObject";
import dayjs from "dayjs"

export default class MultipleTakesData extends BaseObject {

	isEnabled: boolean = false

	takesCount: number = 2

	intervalsCount: number = 6
	intervalLength: string = "month"



	constructor() {
		super();
	}

	getNextTakeTimestampMs(){
		return dayjs().add(this.intervalsCount, this.intervalLength).valueOf()
	}

	formatted(){
		return `${this.takesCount} surveys in total, sent every ${this.intervalsCount} ${this.intervalLength}${this.intervalsCount > 1 ? "s" : ""}`
	}
}
